module.exports = __webpack_public_path__ + "static/media/004-dream.6641ab97.svg";